import { Brand } from "./Logo";
import { useLang } from "@/i18n";
import { MapPin, Mail, Phone, FileText, Instagram, Facebook } from "lucide-react";
import PhoneHours, { trackCall } from "./PhoneHours";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="pt-16 pb-28 lg:pb-10 bg-[#003087] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-3">
              <span className="font-extrabold text-lg tracking-tight text-white">
                Cancellazione Crif<span className="text-[#00AEEF]"> Italia</span>
              </span>
            </div>
            <p className="mt-4 text-base text-[#B9CBE4]">{t("footer.tag")}</p>
            <div className="mt-5 flex items-center gap-3">
              <a data-testid="footer-instagram-link" href="https://instagram.com/cancellazionecrifitalia" target="_blank" rel="noopener noreferrer" aria-label="Instagram CancellazioneCrifItalia"
                className="w-10 h-10 rounded-full bg-white/10 border border-white/15 flex items-center justify-center text-[#9BDDF7] hover:bg-[#00AEEF] hover:text-white transition-colors duration-200">
                <Instagram size={17} />
              </a>
              <a data-testid="footer-facebook-link" href="https://facebook.com/cancellazionecrifitalia" target="_blank" rel="noopener noreferrer" aria-label="Facebook CancellazioneCrifItalia"
                className="w-10 h-10 rounded-full bg-white/10 border border-white/15 flex items-center justify-center text-[#9BDDF7] hover:bg-[#00AEEF] hover:text-white transition-colors duration-200">
                <Facebook size={17} />
              </a>
              <span className="text-xs text-[#9BDDF7] font-semibold">@cancellazionecrifitalia</span>
            </div>
            <p className="mt-5 text-[11px] text-[#7E93B8] leading-relaxed">{t("footer.legal")}</p>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.25em] font-bold text-[#9BDDF7] mb-4">{t("footer.services")}</p>
            <ul className="space-y-2.5 text-sm text-[#B9CBE4]">
              <li><a href="#prezzi" className="hover:text-white transition-colors duration-200">Analisi visure complete — 99€</a></li>
              <li><a href="#prezzi" className="hover:text-white transition-colors duration-200">Cancellazione segnalazioni — da 999€, solo a risultato</a></li>
              <li><a href="#casi" className="hover:text-white transition-colors duration-200">{t("nav.cases")}</a></li>
              <li><a href="#faq" className="hover:text-white transition-colors duration-200">{t("nav.faq")}</a></li>
              <li><a href="/admin" className="hover:text-white transition-colors duration-200">{t("admin.title")}</a></li>
            </ul>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.25em] font-bold text-[#9BDDF7] mb-4">{t("footer.company")}</p>
            <ul className="space-y-2.5 text-sm text-[#B9CBE4]">
              <li className="font-semibold text-white">Sdebitiamoci S.r.l. — marchio Cancellazione Crif Italia</li>
              <li className="flex items-center gap-2"><MapPin size={13} className="text-[#00AEEF] shrink-0" /> Sede legale: Via San Josemaria Escrivá de Balaguer 6, 21047 Saronno (VA)</li>
              <li className="flex items-center gap-2"><MapPin size={13} className="text-[#00AEEF] shrink-0" /> Sede operativa: Via Scipione Ronchetti 8, 21013 Gallarate (VA)</li>
              <li className="flex items-center gap-2"><FileText size={13} className="text-[#00AEEF] shrink-0" /> P.IVA 03691360121</li>
              <li className="flex items-center gap-2"><Mail size={13} className="text-[#00AEEF] shrink-0" /> sdebitiamocisrl@libero.it</li>
              <li className="flex items-center gap-2"><FileText size={13} className="text-[#00AEEF] shrink-0" /> PEC sdebitiamocisrl@pec.libero.it</li>
              <li><a data-testid="footer-phone-btn" href="tel:+393713142397" onClick={() => trackCall("footer_phone")} className="flex items-center gap-2 font-semibold hover:text-white transition-colors duration-150"><Phone size={13} className="text-[#00AEEF] shrink-0" /> Tel +39 371 314 2397</a></li>
              <li><PhoneHours dark /></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-[11px] text-[#7E93B8]">
          <span>{t("footer.rights")}</span>
          <span>GDPR · Codice di Condotta Garante Privacy · Sentenze Cassazione</span>
        </div>
      </div>
    </footer>
  );
}
